const userlogpagetext = {
  date:"Date",
  type:"Type",
  page:"Page",
  event:"Détails",
  nodata: "Aucun log à afficher",
  loading:"Récupération des logs en cours..."
};

const userpagetext = {
  usertype: "Type d'utilisateur",
  userpermission : "Permission",
  memv2version : "Version MEMV2",
  userview: "Vue",
  options: "Options",
}

export { userlogpagetext, userpagetext };
